const buttonForgotPassConfirm = {
  text: 'Cambiar Contraseña'
};

export default buttonForgotPassConfirm;
